<div class="container">
    <form *ngIf="auditTargetsFormGroup" (submit)="updateAuditTarget()" [formGroup]="auditTargetsFormGroup">

        <error-message [errors]="errors"></error-message>
        <h4 class="mt-3 text-primary">Audit Targets</h4>
        <p>Set the reporting period for completing a minimum of 1 audit</p>
        <br />
        <div class="row mt-3">
            <div class="col-md-6 col-lg-4">
                <div class="form-group">
                    <label class="control-label text-default">
                        Timeframe
                    </label>
                    <input type="hidden" class="form-control" formControlName="id" />
                    <input type="hidden" class="form-control" formControlName="companyId" />
                    <input type="hidden" class="form-control" formControlName="auditCategoryId" />
                    <input type="hidden" class="form-control" formControlName="threshold" />

                    <input *ngIf="!isEditMode" type="text" id="tmp" name="tmp" class="form-control" [disabled]="true"
                        value="{{selectedTargetCategory}}" />
                    <select *ngIf="isEditMode" formControlName="auditTargetTimeframeCategoryId"
                        name="auditTargetTimeframeCategoryId" class="form-select">
                        <option *ngFor="let auditTargetCategory of auditTargetCategoryList"
                            [value]="auditTargetCategory.id"
                            [selected]="companyAuditTarget.auditTargetTimeframeCategoryId === auditTargetCategory.id">{{
                            auditTargetCategory.description}}</option>
                    </select>

                </div>
            </div>
            <div class="col-md-6 col-lg-4">
                <label class="control-label text-default">
                    Enabled
                </label>
                <input type="checkbox" id="isActive" name="isActive" class="form-control" formControlName="isActive"
                    appToggle [isDisabled]="!isEditMode" />
            </div>
        </div>

        <footer class="panel-footer mt-3">
            <div class="row">
                <div class="col-12 text-end">
                    <button class="btn btn-primary ms-2" type="button" (click)="toggleEditMode()"
                        *ngIf="!isEditMode">Edit</button>
                    <button class="btn btn-outline-primary" type="button" (click)="toggleEditMode()"
                        *ngIf="isEditMode">Cancel</button>
                    <button class="btn btn-success ms-2" type="submit" *ngIf="isEditMode">Save</button>
                </div>
            </div>
        </footer>
    </form>
</div>

<app-alert-message (successClicked)="successClicked($event)" (onHide)="onHide($event)" [title]="'Success'"
    [message]="'Audit Target updated'">
</app-alert-message>
